const locale_en = {
    bandContent: 'Content',
    bandFooter: 'Footer',
    bandHeader: 'Header',
    clear: 'Clear',
    contentHeight: 'Content height',
    contentHeightInfo: 'affects only GUI size to place elements and not the real page size',
    differentFiles: 'different files...',
    differentValues: 'different values...',
    docElementAddChecksum: 'Add checksum',
    docElementAdditionalRules: 'Additional rules',
    docElementAlignToPageBottom: 'Align to bottom of page',
    docElementAlternateBackgroundColor: 'Alternate background color',
    docElementAlwaysPrintOnSamePage: 'Always on same page',
    docElementBarCode: 'Bar code',
    docElementBarWidth: 'Bar width',
    docElementBorderFrame: 'Frame',
    docElementBorderFrameRow: 'Frame and row',
    docElementBorderGrid: 'Grid',
    docElementBorderNone: 'None',
    docElementBorderRow: 'Row',
    docElementColor: 'Color',
    docElementColspan: 'Colspan',
    docElementColumns: 'Columns',
    docElementConditionalStyle: 'Conditional style',
    docElementConditionalStyleCondition: 'Condition',
    docElementContent: 'Text',
    docElementContentRows: 'Content rows',
    docElementDataSource: 'Data source',
    docElementDisplayValue: 'Display value',
    docElementEditMultipleSelectionNotSupported: 'Edit multiple selection is not supported for this setting',
    docElementErrorCorrectionLevel: 'Error correction',
    docElementErrorCorrectionLevelHigh: 'High',
    docElementErrorCorrectionLevelLow: 'Low',
    docElementErrorCorrectionLevelMedium: 'Medium',
    docElementErrorCorrectionLevelQuartile: 'Quartile',
    docElementEval: 'Evaluate',
    docElementFormat: 'Format',
    docElementFrame: 'Frame',
    docElementGroupExpression: 'Group expression',
    docElementGrowWeight: 'Grow weight',
    docElementGrowWeightInfo: 'Grow factor to take space of hidden columns',
    docElementGrowWeightHigh: 'high',
    docElementGrowWeightLow: 'low',
    docElementGuardBar: 'Guard bars',
    docElementHeight: 'Height',
    docElementImage: 'Image',
    docElementImageCountExceeded: 'Reached maximum number of ${count} allowed images',
    docElementImageFile: 'Image file',
    docElementLabel: 'Label',
    docElementLine: 'Line',
    docElementLink: 'Link',
    docElementLoadImageErrorMsg: 'Loading image failed',
    docElementLoadImageWebPErrorMsg: 'Loading image failed, upgrade browser to latest version',
    docElementOpacity: 'Opacity %',
    docElementPageBreak: 'Page break',
    docElementPattern: 'Pattern',
    docElementPosition: 'Position (x, y)',
    docElementPositionX: 'Position (x)',
    docElementPositionY: 'Position (y)',
    docElementPrintIf: 'Print if',
    docElementPrintSettings: 'Print settings',
    docElementRemoveEmptyElement: 'Remove when empty',
    docElementRepeatGroupHeader: 'Repeat group on each page',
    docElementRepeatHeader: 'Repeat header',
    docElementRichText: 'Rich text',
    docElementRoot: 'Document',
    docElementRotate: 'Rotate',
    docElementRotateDeg: 'Rotate °',
    docElementSection: 'Section',
    docElementShowInForeground: 'Show in foreground',
    docElementShrinkToContentHeight: 'Shrink to content height',
    docElementSize: 'Size (width, height)',
    docElementSource: 'Source',
    docElementSpreadsheet: 'Spreadsheet',
    docElementSpreadsheetAddEmptyRow: 'Add empty row below',
    docElementSpreadsheetColspan: 'Colspan',
    docElementSpreadsheetColumn: 'Fixed column',
    docElementSpreadsheetHide: 'Hide',
    docElementSpreadsheetPattern: 'Pattern',
    docElementSpreadsheetTextWrap: 'Text wrap',
    docElementSpreadsheetType: 'Type',
    docElementSpreadsheetTypeDate: 'Date',
    docElementSpreadsheetTypeNone: 'Default',
    docElementSpreadsheetTypeNumber: 'Number',
    docElementSpreadsheetTypeText: 'Text',
    docElementStyle: 'Style',
    docElementTable: 'Table',
    docElementTableBandPageBreak: 'Page break with each new group',
    docElementText: 'Text',
    docElementWidth: 'Width',
    documentProperties: 'Document properties',
    documentTabClose: 'Close',
    documentTabPdfLayout: 'PDF Layout',
    documentTabPdfPreview: 'PDF Preview',
    documentTabXlsxDownload: 'XLSX Download',
    editData: 'Edit',
    emptyPanel: 'Empty panel',
    errorMsgAddtionalRulesNoStyleSelected: 'No style selected for rule ${info}',
    errorMsgBorderRadiusNotAllowed: 'Border radius is only allowed with background color or full border',
    errorMsgBorderRadiusOnlyOnSamePage: 'Border radius is only allowed if element is always on same page',
    errorMsgDuplicateParameter: 'Parameter already exists',
    errorMsgDuplicateParameterField: 'Field already exists',
    errorMsgExternalImageNotAllowed: 'Server does not support loading images from external resources',
    errorMsgFontNotAvailable: 'Font not available on server',
    errorMsgGroupExpressionWithoutDataSource: 'Group expression requires table with data source',
    errorMsgLoadingImageFailed: 'Loading image failed: ${info}',
    errorMsgInvalidArray: 'Invalid list',
    errorMsgInvalidAvgSumExpression: 'Expression must contain number field of a list parameter',
    errorMsgInvalidBarCode: 'Invalid bar code content',
    errorMsgInvalidDataSource: 'Invalid data source',
    errorMsgInvalidDataSourceParameter: 'Parameter must be a list',
    errorMsgInvalidDate: 'Invalid date, expected format is YYYY-MM-DD (or YYYY-MM-DD hh:mm for date with time)',
    errorMsgInvalidStringData: 'Invalid data for text parameter ${info}',
    errorMsgInvalidExpression: 'Invalid expression: ${info}',
    errorMsgInvalidExpressionFuncNotDefined: 'Function ${info} not defined',
    errorMsgInvalidExpressionNameNotDefined: 'Name ${info} not defined',
    errorMsgInvalidExpressionType: 'Expression returns invalid type',
    errorMsgInvalidLink: 'Link must start with http:// or https://',
    errorMsgInvalidImage: 'Invalid image data, image must be base64 encoded',
    errorMsgInvalidImageSource: 'Invalid source, expected url starting with http:// or https:// respectively',
    errorMsgInvalidImageSourceParameter: 'Parameter must be an image or string (containing a url)',
    errorMsgInvalidMap: 'Invalid collection',
    errorMsgInvalidNumber: 'Invalid number',
    errorMsgInvalidPageSize: 'Invalid page size',
    errorMsgInvalidParameterData: 'Data does not match parameter',
    errorMsgInvalidParameterName: 'Name must start with a character or underscore, and must only contain characters, digits and underscores (_)',
    errorMsgInvalidPattern: 'Invalid pattern',
    errorMsgInvalidPosition: 'The position is outside the area',
    errorMsgInvalidRichTextFontNotAvailable: 'The rich text contains a font which is not available on server',
    errorMsgInvalidRichTextParameter: 'The rich text contains invalid tags',
    errorMsgInvalidSize: 'The element is outside the area',
    errorMsgInvalidSpreadsheetDate: 'The data cannot be converted to date, expected format is YYYY-MM-DD (or YYYY-MM-DD hh:mm for date with time)',
    errorMsgInvalidSpreadsheetNumber: 'The data cannot be converted to number',
    errorMsgInvalidTestData: 'Invalid test data',
    errorMsgMissingData: 'Missing data',
    errorMsgMissingDataSourceParameter: 'Data source parameter not found',
    errorMsgMissingExpression: 'Expression must be set',
    errorMsgMissingGlyph: 'Text contains characters that are not available in the selected font',
    errorMsgMissingImage: 'Missing image, no source or image file specified',
    errorMsgMissingParameter: 'Parameter not found',
    errorMsgMissingParameterData: 'Data for parameter ${info} not found',
    errorMsgRepeatGroupHeaderAfterContent: 'Not allowed for group after content row',
    errorMsgPlusVersionRequired: 'Requires commercial PLUS version',
    errorMsgSectionBandNotOnSamePage: 'Section band does not fit on same page',
    errorMsgSectionBandPageBreakNotAllowed: 'Manual page break not allowed',
    errorMsgUnicodeEncodeError: 'Text contains non printable character',
    errorMsgUnsupportedImageType: 'Image does not have supported image type (.jpg, .png)',
    footer: 'Footer',
    footerDisplay: 'Display',
    footerSize: 'Footer size',
    header: 'Header',
    headerDisplay: 'Display',
    headerFooterDisplayAlways: 'Always',
    headerFooterDisplayNotOnFirstPage: 'Do not show on first page',
    headerSize: 'Header size',
    menuColumnAddLeft: 'Add column to the left',
    menuColumnAddRight: 'Add column to the right',
    menuColumnDelete: 'Delete column',
    menuAlignBottom: 'Align bottom',
    menuAlignCenter: 'Align center',
    menuAlignLeft: 'Align left',
    menuAlignMiddle: 'Align middle',
    menuAlignRight: 'Align right',
    menuAlignTop: 'Align top',
    menuInsertReport: 'INSERT',
    menuInsertReportTip: 'Insert report template',
    menuLogReport: 'LOG',
    menuLogReportTip: 'Log report template to console',
    menuPreview: 'PREVIEW',
    menuPreviewTip: 'Preview report',
    menuRedo: 'REDO',
    menuRedoTip: 'Repeat last undone command',
    menuRowAddAbove: 'Add row above',
    menuRowAddBelow: 'Add row below',
    menuRowDelete: 'Delete row',
    menuSave: 'SAVE',
    menuSaveTip: 'Save report',
    menuToggleGrid: 'Show/Hide grid',
    menuUndo: 'UNDO',
    menuUndoTip: 'Undo last command',
    menuZoomIn: 'Zoom in',
    menuZoomOut: 'Zoom out',
    nameCopySuffix: 'copy',
    orientation: 'Orientation',
    orientationBottom: 'bottom',
    orientationLandscape: 'Landscape',
    orientationLeft: 'left',
    orientationPortrait: 'Portrait',
    orientationRight: 'right',
    orientationTop: 'top',
    pageFormat: 'Page format',
    pageFormatA4: 'DIN A4 (210 x 297 mm)',
    pageFormatA5: 'DIN A5 (148 x 210 mm)',
    pageFormatLetter: 'Letter (8.5 x 11.0 inches)',
    pageFormatUserDefined: 'Own dimensions',
    pageHeight: 'height',
    pageMargins: 'Page margins',
    pageWidth: 'width',
    parameter: 'Parameter',
    parameterArrayItemType: 'List item type',
    parameterEditTestData: 'Edit',
    parameterEditTestDataArrayNoFields: 'No data fields defined for this list',
    parameterEditTestDataMapNoFields: 'No data fields defined for this collection',
    parameterEval: 'Evaluate text',
    parameterExpression: 'Expression',
    parameterListType: 'List type',
    parameterName: 'Name',
    parameterNullable: 'Nullable',
    parameterPattern: 'Pattern',
    parameterRowParams: 'Row parameters',
    parameterSearchPlaceholder: 'Search parameters...',
    parameterTestData: 'Test data',
    parameterTestDataDatePattern: 'YYYY-MM-DD',
    parameterTestDataImageInfo: 'Images are saved in the report template and could significantly increase report template size',
    parameterTestDataRichTextInfo: 'Rich text can contain html tags for formatting. See <a href="https://www.reportbro.com/doc/userguide#parameter_type_rich_text" target="_blank" rel="noreferrer">allowed tags</a>',
    parameterTestDataRowCount: '${count} rows',
    parameterTestDataRowCountEmpty: 'empty',
    parameterTestDataRowCountOne: '1 row',
    parameterType: 'Type',
    parameterTypeArray: 'List',
    parameterTypeAverage: 'Average',
    parameterTypeBoolean: 'Boolean',
    parameterTypeDate: 'Date',
    parameterTypeImage: 'Image',
    parameterTypeMap: 'Collection',
    parameterTypeNumber: 'Number',
    parameterTypeRichText: 'Rich Text',
    parameterTypeSimpleArray: 'Simple List',
    parameterTypeString: 'Text',
    parameterTypeSum: 'Sum',
    parameters: 'Parameters',
    parametersDataSource: 'Data source parameters',
    parametersDataSourceName: '${name} parameters',
    patternCurrencySymbol: 'Pattern currency symbol',
    patternDate1: 'day.month.year, e.g. 1.6.1980',
    patternDate2: 'day.month.year (2-digit), hour(24h):minute, e.g. 1.6.80, 14:30',
    patternDate3: 'day/month/year (month abbreviation), e.g. 1/Jun/1980',
    patternDate4: 'month/day/year (day and month with leading zero if single digit), e.g. 06/01/1980',
    patternLocale: 'Pattern locale',
    patternNumber1: 'Show thousand separator',
    patternNumber2: 'Show decimal point followed by 3 decimal places',
    patternNumber3: 'Show decimal point followed by minimum of 2 and maximum of 4 decimal places',
    patternNumber4: 'Show thousand separator and decimal point followed by 2 decimal places',
    patternNumber5: 'Show currency symbol in front of number',
    patternNumberGroupSymbol: 'Thousands separator',
    patternNumberGroupSymbolInfo: 'leave empty for default',
    patternSeparatorDates: '--- Date patterns ---',
    patternSeparatorNumbers: '--- Number patterns ---',
    plusFeatureInfo: 'Requires commercial <a href="https://www.reportbro.com/license/index" target="_blank" rel="noreferrer">PLUS version</a>',
    plusFeatureInfoNestedParameter: 'Nested parameter requires commercial <a href="https://www.reportbro.com/license/index" target="_blank" rel="noreferrer">PLUS version</a>',
    popupWindowAddDataRow: 'Add row',
    select: 'select...',
    style: 'Style',
    styleAlignment: 'Alignment',
    styleBackgroundColor: 'Background color',
    styleBold: 'Bold',
    styleBorder: 'Border',
    styleBorderAll: 'borders',
    styleBorderColor: 'Border color',
    styleBorderRadius: 'Border radius',
    styleBorderWidth: 'Border width',
    styleFont: 'Font',
    styleFontSizeUnit: 'pt',
    styleHAlignmentCenter: 'Center',
    styleHAlignmentLeft: 'Left',
    styleHAlignmentJustify: 'Justify',
    styleHAlignmentRight: 'Right',
    styleItalic: 'Italic',
    styleLineSpacing: 'Line spacing',
    styleName: 'Name',
    styleNone: 'None',
    stylePadding: 'Padding',
    styleStrikethrough: 'Strikethrough',
    styleTextColor: 'Text color',
    styleTextStyle: 'Text style',
    styleType: 'Element',
    styleTypeFrame: 'Frame',
    styleTypeImage: 'Image',
    styleTypeLine: 'Line',
    styleTypeSectionBand: 'Section band',
    styleTypeTable: 'Table',
    styleTypeTableBand: 'Table band',
    styleTypeText: 'Text',
    styleUnderline: 'Underline',
    styleVAlignmentBottom: 'Bottom',
    styleVAlignmentMiddle: 'Middle',
    styleVAlignmentTop: 'Top',
    styles: 'Styles',
    watermarkImages: 'Image watermarks',
    watermarkTexts: 'Text watermarks',
    watermarks: 'Watermarks',
};

export default locale_en;
